var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0.492188H6.5V1.5H3.5V0.492188ZM8.51562 3.70312L9.21875 2.97656C9.10938 2.85156 8.99219 2.73438 8.86719 2.625C8.75781 2.5 8.64062 2.38281 8.51562 2.27344L7.8125 3C7.42188 2.6875 6.98438 2.44531 6.5 2.27344C6.03125 2.08594 5.53125 1.99219 5 1.99219C4.375 1.99219 3.78906 2.10938 3.24219 2.34375C2.71094 2.57812 2.23438 2.90625 1.8125 3.32812C1.40625 3.73437 1.08594 4.21094 0.851562 4.75781C0.617188 5.30469 0.5 5.88281 0.5 6.49219C0.5 7.11719 0.617188 7.70312 0.851562 8.25C1.08594 8.79688 1.40625 9.27344 1.8125 9.67969C2.23438 10.0859 2.71094 10.4062 3.24219 10.6406C3.78906 10.875 4.375 10.9922 5 10.9922C5.625 10.9922 6.20312 10.875 6.73438 10.6406C7.28125 10.4062 7.75781 10.0859 8.16406 9.67969C8.58594 9.27344 8.91406 8.79688 9.14844 8.25C9.38281 7.70312 9.5 7.11719 9.5 6.49219C9.5 5.96094 9.41406 5.46094 9.24219 4.99219C9.07031 4.50781 8.82812 4.07812 8.51562 3.70312ZM5.49219 7.00781H4.50781V4.00781H5.49219V7.00781Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClock);
export default __webpack_public_path__ + "static/media/icn-clock.eb9e81d7.svg";
export { ForwardRef as ReactComponent };